<div class="body-content">
  <div class="logo">
      <img alt='{{ "common.company_logo" | translate }}'  src="assets/images/uw-logo-en.svg" />
  </div>
  <div class="box1"></div>
  <div class="box2"></div>
  <div class="box3"></div>
  <div class="box4"></div>
  <div class="main">
      <div class="sideimage"><img alt='{{ "common.welcome_side_image" | translate }}' src="assets/images/Layer_1.png" /></div>
      <div class="login-side">
        <app-login-form></app-login-form>
      </div>
  </div>
</div>